export const getPluginCheckout = 'Plugin/GetCheckoutSession';
export const sendOtpPluginCheckout = 'Plugin/SendOtpForCheckoutSession';
export const verifyOtpPluginCheckout = 'Plugin/VerifyOtpForCheckoutSession';
export const createOrderPluginCheckout = 'Plugin/CreateOrderForCheckoutSession';
export const signInForPluginCheckout = 'Plugin/SignInForCheckoutSession';
export const sendOtpForRecoverGuestSession =
  'Plugin/SendOtpForRecoverGuestSession';
export const verifyOtpForRecoverGuestSession =
  'Plugin/VerifyOtpForRecoverGuestSession';
